import ApplicationRater from "./ApplicationRater";

export default ApplicationRater;
